import {FC} from 'react';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {CopyOutlined} from '@ant-design/icons';
import {getErrorMsg} from '@/utils/error';
import {COLOR_PRIMARY} from '@/styles/common';
import {SCCardTip} from '@/styles/modules';

const ErrorContent: FC<any> = (props: any) => {
    const {message} = props;
    const requestId = message?.requestId || '';
    const content = getErrorMsg(message);

    return (
        <div>
            {content}
            {requestId ? (
                <SCCardTip>
                    请求ID：{requestId}
                    <CopyToClipboard text={requestId}>
                        <CopyOutlined style={{color: COLOR_PRIMARY}} />
                    </CopyToClipboard>
                </SCCardTip>
            ) : null}
        </div>
    );
};

export default ErrorContent;
